import { useState } from 'react'
import { api } from '../api/cliente'
import { Cabecalho, Erro } from '../componentes/Basicos'

/**
 * A mesma identidade do app de campo: quem entra aqui é o auditor que fez a visita.
 *
 * Não há cadastro nesta tela. A conta é criada pela API, como no app — são poucos auditores, e a
 * web não é aberta ao público.
 */
export function Entrar({
  aoEntrar,
  aviso,
}: {
  aoEntrar: () => void
  /** Por que a pessoa está aqui, quando não foi ela quem pediu. */
  aviso?: string | null
}) {
  const [email, setEmail] = useState('')
  const [senha, setSenha] = useState('')
  const [erro, setErro] = useState<unknown>(null)
  const [entrando, setEntrando] = useState(false)

  async function entrar() {
    setEntrando(true)
    setErro(null)
    try {
      await api.entrar(email.trim(), senha)
      aoEntrar()
    } catch (falha) {
      setErro(falha)
      setEntrando(false)
    }
  }

  return (
    <>
      <Cabecalho titulo="Laudos NR10" sub="Entre para ver as visitas e baixar os laudos" />
      <div className="corpo">
        <div className="limite estreito">
          {aviso && (
            <div className="aviso" role="status">
              {aviso}
            </div>
          )}
          <Erro erro={erro} aoFechar={() => setErro(null)} />
          <form
            className="card"
            onSubmit={(evento) => {
              evento.preventDefault()
              if (email.trim() && senha) entrar()
            }}
          >
            <div className="campo">
              <label htmlFor="email">E-mail</label>
              <input
                id="email"
                type="email"
                autoComplete="username"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="campo">
              <label htmlFor="senha">Senha</label>
              <input
                id="senha"
                type="password"
                autoComplete="current-password"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
              />
            </div>
            <button className="btn p largo" type="submit" disabled={entrando || !email.trim() || !senha}>
              {entrando ? 'entrando…' : 'Entrar'}
            </button>
          </form>
        </div>
      </div>
    </>
  )
}
